import React from "react";
import { Row, Col, Form } from "react-bootstrap";

export function AddServicesPracTeam({ 
  pracName, 
  selectedPractices, 
  uniqueTeamMember, 
  selectedTeamMembers, 
  handlePracticeChange, 
  handleTeamMemberChange, 
  errors 
}) {
  
  console.log("Selected Practices op add practices:", selectedPractices);
  console.log("Practices2", pracName);
  
  // Add safety checks to prevent rendering with bad data
  const practices = Array.isArray(pracName) ? pracName : [];
  const teamMembers = Array.isArray(uniqueTeamMember) ? uniqueTeamMember : [];
  const selectedPracticesArray = Array.isArray(selectedPractices) ? selectedPractices : [];
  const selectedTeamMembersArray = Array.isArray(selectedTeamMembers) ? selectedTeamMembers : [];

  return (
    <Row className="mb-3">
      <Form.Group as={Col} controlId="practiceCheckboxes">
        <Form.Label>Select Practices</Form.Label>
        <div>
          {practices.map((prac, index) => {
            // Ensure we have a unique key even if practiceNumber is duplicated
            const key = prac.practiceNumber || `practice-${index}`;
            return (
              <Form.Check
                key={key}
                type="checkbox"
                label={prac.practiceName || 'Unknown Practice'}
                checked={selectedPracticesArray.includes(prac.practiceNumber)}
                onChange={() => handlePracticeChange(prac.practiceNumber)}
              />
            );
          })}
        </div>
        {errors.servicesPractice && (
          <div className="text-danger">{errors.servicesPractice}</div>
        )}
      </Form.Group>

      <Form.Group as={Col} controlId="teamMemberCheckboxes">
        <Form.Label>Select Team Members</Form.Label>
        <div>
          {teamMembers.map((user, index) => {
            // Ensure we have a unique key even if _id is duplicated
            const key = user._id || `user-${index}`;
            const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
            return (
              <Form.Check
                key={key}
                type="checkbox"
                label={fullName || 'Unknown User'}
                checked={selectedTeamMembersArray.includes(user._id)}
                onChange={() => handleTeamMemberChange(user._id)}
              />
            );
          })}
        </div>
        {errors.servicesUser && (
          <div className="text-danger">{errors.servicesUser}</div>
        )}
      </Form.Group>
    </Row>
  );
}